import { AppLanguage } from './supportContext';

// 2026-09-15 Visitor 翻訳_実装用.csv, No.314–316.
// Provisional translations: delivery/approval is still an OPS task.
export const messages: Record<AppLanguage, { title: string; body: string; button: string }> = {
  "en": {
    "title": "Contact us",
    "body": "If the chat doesn't open automatically, tap the button below.",
    "button": "Open chat"
  },
  "zh-Hans": {
    "title": "联系我们",
    "body": "如果聊天窗口没有自动打开，请点按下方按钮。",
    "button": "打开聊天"
  },
  "zh-Hant": {
    "title": "聯絡我們",
    "body": "如果聊天視窗沒有自動開啟，請點按下方按鈕。",
    "button": "開啟聊天"
  },
  "ko": {
    "title": "문의하기",
    "body": "채팅 화면이 자동으로 열리지 않으면 아래 버튼을 눌러 주세요.",
    "button": "채팅 열기"
  }
};
